import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

export const CLIENTS_CSV_REQUEST = 'CLIENTS_CSV_REQUEST';
export const CLIENTS_CSV_SUCCESS = 'CLIENTS_CSV_SUCCESS';
export const CLIENTS_CSV_FAILURE = 'CLIENTS_CSV_FAILURE';

export function clientsListCSV(salonId) {
  const endpoint = `salon/v2/${salonId}/client/export/`;
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint,
      authenticated: true,
      types: [CLIENTS_CSV_REQUEST, CLIENTS_CSV_SUCCESS, CLIENTS_CSV_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}
